import axios from "axios";
import { API_ENDPOINTS } from "./apiEndpoints";

export async function cancelGroupTravelAPI(
  referenceId: string,
  editId: string
): Promise<{ ReferenceId: string; EditId: string }> {

  const response = await axios.post(API_ENDPOINTS.unregisterGroupTravel, {
    ReferenceId: referenceId,
    EditId: editId,
  });

  return response.data;
}
